import React, {useLayoutEffect, useEffect, useState, useRef} from "react"
import styles from "../../styles/contract.module.css"
import {useOutletContext} from "react-router";
import {UploadTypes, handlers } from "../../hooks/use-uploader";
import {PdfPage} from "../../components/stateful/contract/signing/pdf-page";
import {PdfAttachments} from "../../components/stateful/contract/signing/pdf-attachments";
import DefaultLoader from "../../components/common/loaders/default-loader";
import {Col, Container, Row} from "react-bootstrap";
import UnitContractService from "../../services/unit-contract.service";
import ButtonLoader from "../../components/common/loaders/button-loader";
import PrimaryModal from "../../components/common/modals/primary-modal";
import SchedulerModal from "../../components/common/modals/schedular-modal";
import SignatureOnContract from "../../components/presentational/contract/signing/signature-on-contract";
import {AttachmentTypes} from "../../utils/constants/contract";
import {useScreenshot} from "use-react-screenshot";
import {nanoid} from "nanoid";
import useWindowSize from "../../hooks/use-window-size";

const SignContract = () => {
    const {documentFile,usePdfFromParent,useAttachmentsFromParent,contractData,contractId,signerId} = useOutletContext()
    const { file, initialize, pageIndex, isMultiPage, isFirstPage, isLastPage, currentPage, previousPage, nextPage, setDimensions, name, dimensions } = usePdfFromParent
    const { allPageAttachments,pageAttachments, reset: resetAttachments, update, remove, setPageIndex,addAtSpecificIndex } = useAttachmentsFromParent
    const {width} = useWindowSize()
    const {useHandleSignContract,useHandleSignatureUploadForContract} = UnitContractService()
    const {mutate:handleSignContract,isLoading:isSignContractLoading} = useHandleSignContract()

    const initializePageAndAttachments = (pdfDetails) => {
        initialize(pdfDetails);
        const numberOfPages = pdfDetails.pages.length;
        resetAttachments(numberOfPages);
    };

    useEffect(()=>{
        (async ()=>{
            initializePageAndAttachments(await handlers[UploadTypes.PDF](documentFile,true))
            if (contractData?.edits?.length > 0){

                for (let i = 0; i < contractData?.edits?.length; i++) {
                    let editData = contractData?.edits[i]
                    if (editData?.signerId === signerId){
                        addAtSpecificIndex(editData?.pageNumber,{
                            id: editData?._id,
                            type:editData?.type,
                            x: editData?.xPosition,
                            y: editData?.yPosition,
                            width: 100,
                            editId:editData?._id,
                            signerId:editData?.signerId,
                            isEditable:true,
                            height: 40,
                            size: 14,
                            lineHeight: 1.4,
                            fontFamily: 'Times-Roman',
                            text: '',
                            media:editData?.asset
                        })
                    }

                }

            }
        })()
    },[])

    useLayoutEffect(() => setPageIndex(pageIndex), [pageIndex, setPageIndex]);


    const finishSigning = () => {
        let pageData = [];
        for (let i = 0; i < allPageAttachments.length; i++) {
            let loopData = allPageAttachments[i]
            for (let j = 0; j < loopData.length; j++) {
                if (loopData[j]?.type === AttachmentTypes.TEXT){
                    pageData.push({
                        editId:loopData[j]?.editId,
                        asset: loopData[j]?.text,
                    })
                }

            }
        }
        handleSignContract({pageData,contractId,signerId})
    }

    //Signature Upload Functionality
    const [isSignModalOpen,setIsSignModalOpen] = useState({
        isOpen:false,
        editId:"",
        signerId:"",
        index:-1,
        isSignature:false
    })

    const {data:signatureUploadData,mutate:handleSignatureUpload,isLoading:isSignatureUploadLoading,isSuccess:isSignatureUploadSuccess,reset} = useHandleSignatureUploadForContract()
    const [signatureFile,setSignatureFile] = useState("")

    const textSignatureRef = useRef(null)
    const [_, takeScreenShot] = useScreenshot({
        type: "image/jpeg",
        quality: 1.0
    });
    const download = async (image) => {
        const blob = await fetch(image).then((res) => res.blob());
        let metadata = {
            type: 'image/jpeg'
        };
        return new File([blob], `${nanoid()}.jpeg`, metadata)
    };

    const handleContractSignatureFile = (passedFile) => {
        setSignatureFile(passedFile)

        return () => {
            //If it's text convert it into file then send it
            if (!!textSignatureRef.current){
                takeScreenShot(textSignatureRef.current)
                    .then(async response => {
                        const file = await download(response)

                        const formData = new FormData()

                        formData.append("asset",file)
                        formData.append("editId",isSignModalOpen.editId)

                        handleSignatureUpload({fileData:formData,contractId,signerId:isSignModalOpen.signerId})
                    })
                //If it's directly the file just send it!
            }else{
                const formData = new FormData()

                formData.append("asset",passedFile)
                formData.append("editId",isSignModalOpen.editId)

                handleSignatureUpload({fileData:formData,contractId,signerId:isSignModalOpen.signerId})
            }
        }
    }

    //Handle Upload Signature
    const onHandleSignatureModal = (editId,signerId,index,isSignature) => {
        setIsSignModalOpen(prev => ({
            isOpen:!prev.isOpen,
            editId:editId,
            signerId:signerId,
            index:index,
            isSignature
        }))
    }
    //Show signature on ui after uploading from here
    useEffect(()=>{
        if(isSignatureUploadSuccess){
            update(isSignModalOpen.index,{media:signatureUploadData.data?.data?.asset})
        }
    },[isSignatureUploadSuccess])

    return (
        <>
            <section className={styles.sign__contract__wrapper}>
                <Container>
                    <Row>
                        {width <= 991 && <Col md={12}>
                            {!!file && <div className={`${styles.button__wrapper} ${styles.right__button__wrapper}`}>
                                {isMultiPage && !isLastPage &&
                                    <button type={"button"} onClick={nextPage}>Next</button>}
                                {isLastPage && !isSignContractLoading &&
                                    <button type={"button"} onClick={finishSigning}>Finish Signing</button>}
                                {isSignContractLoading && <ButtonLoader/>}
                            </div>}
                        </Col>}
                        <Col lg={2} xs={12}>
                            {!!file && <div className={`${styles.button__wrapper} ${styles.left__button__wrapper}`}>
                                {isMultiPage && !isFirstPage && !isSignContractLoading &&
                                    <button type={"button"} onClick={previousPage}>Back</button>}
                            </div>}
                        </Col>
                        <Col lg={8} xs={12}>
                            { !file ? (
                                <DefaultLoader/>
                            ) : (
                                <>
                                    <div className={styles.pdf__wrapper}>
                                        { currentPage && (
                                            <div className={"relative"}>
                                                <PdfPage
                                                    dimensions={dimensions}
                                                    updateDimensions={setDimensions}
                                                    page={currentPage}
                                                />
                                                { dimensions && (
                                                    <PdfAttachments
                                                        pdfName={name}
                                                        removeAttachment={remove}
                                                        updateAttachment={update}
                                                        pageDimensions={dimensions}
                                                        attachments={pageAttachments}
                                                        onHandleSignatureModal={onHandleSignatureModal}
                                                    />
                                                )}
                                            </div>
                                        )}
                                    </div>
                                </>
                            )}
                        </Col>
                        {width > 991 && <Col md={2}>
                            {!!file && <div className={`${styles.button__wrapper} ${styles.right__button__wrapper}`}>
                                {isMultiPage && !isLastPage &&
                                    <button type={"button"} onClick={nextPage}>Next</button>}
                                {isLastPage && !isSignContractLoading &&
                                    <button type={"button"} onClick={finishSigning}>Finish Signing</button>}
                                {isSignContractLoading && <ButtonLoader/>}
                            </div>}
                        </Col>}
                    </Row>
                </Container>
            </section>
            {isSignModalOpen.isOpen && <PrimaryModal
                size={"lg"}
                isOpen={isSignModalOpen.isOpen}

                modalContent={
                    <SchedulerModal
                        handleModalClose={()=>onHandleSignatureModal("","",-1,false)}
                        isLoading={isSignatureUploadLoading}
                        reset={reset}
                        mutate={()=>handleContractSignatureFile(signatureFile)()}
                        Content={<SignatureOnContract isSignature={isSignModalOpen.isSignature} setFile={handleContractSignatureFile} textRefCallback={textSignatureRef}/>}
                        isSuccess={isSignatureUploadSuccess}
                        title={"Signature"}
                        confirmButtonText={"Sign"}
                    />
                }
            />}
        </>
    )
}
export default SignContract
